import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { KeywordTagFieldsFragmentDoc } from '../../../fragments/keywordTagFields.generated';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { ParagraphFieldsFragmentDoc } from '../../../fragments/paragraphFields.generated';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FullTextSearchRegulationsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type FullTextSearchRegulationsQuery = { __typename?: 'Query', searchRegulations: { __typename?: 'FullTextRegulationResult', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string, name: string, summary: string, createdAt?: any | null, modifiedAt?: any | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null }> } };

export type FullTextSearchRequirementsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type FullTextSearchRequirementsQuery = { __typename?: 'Query', searchRequirements: { __typename?: 'FullTextRequirementResult', requirements: Array<{ __typename?: 'Requirement', id: string, name: string, status: Types.RequirementStatus, definition?: string | null, requirementId?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } }> | null, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string, name: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, assignedParagraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, parent: { __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }> } | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string }> }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> }> } };

export type FullTextSearchPogisQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type FullTextSearchPogisQuery = { __typename?: 'Query', searchPogisDocuments: { __typename?: 'FullTextPogisDocumentResult', pogisDocuments: Array<{ __typename?: 'PogisDocument', associations?: Array<string> | null, createdAt?: any | null, docStatus: string, editor: string, id: string, keywords: Array<string>, linkVersion?: string | null, markets: Array<string>, modifiedAt?: any | null, pogisId: string, regulationStatus: string, relatedDocuments?: Array<string> | null, shortInfo: string, standards?: Array<string> | null, pogisAttachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', fileName: string, uri: any }, category?: { __typename?: 'AttachmentCategory', name: string } | null }> | null, dates: Array<{ __typename?: 'PogisDate', date: any, dateType: string }> }> } };

export type FullTextSearchDocumentsQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type FullTextSearchDocumentsQuery = { __typename?: 'Query', searchRegulatoryDocumentsAndParagraphs: { __typename?: 'FullTextDocumentResult', regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', createdAt?: any | null, id: string, modifiedAt?: any | null, name: string, status: Types.RegulatoryDocumentStatus, summary?: string | null, origin: Types.Origin, modelYear?: number | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, dateEffective?: any | null, dateExpiration?: any | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, message?: string | null }, document?: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } | null, topicManagementSummary?: { __typename?: 'TopicManagementSummary', quarter: Types.TopicManagementSummaryQuarter, year: number } | null, predecessor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, successor?: { __typename?: 'RegulatoryDocument', id: string, name: string } | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }> }>, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, parent: { __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string } | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string }> }> } };


export const FullTextSearchRegulationsDocument = gql`
    query FullTextSearchRegulations($searchString: String!) {
  searchRegulations(searchString: $searchString) {
    regulations {
      id
      regulationNumber
      name
      summary
      markets {
        id
        name
      }
      mainKeywords {
        id
        name
      }
      keywords {
        ...KeywordTagFields
      }
      standardPlusPcmsClusters {
        id
        name
      }
      createdAt
      modifiedAt
      createdBy {
        id
        name
        mail
        userPrincipalName
      }
      modifiedBy {
        id
        name
        mail
        userPrincipalName
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
}
    ${KeywordTagFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;

/**
 * __useFullTextSearchRegulationsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchRegulationsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useFullTextSearchRegulationsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>(FullTextSearchRegulationsDocument, options);
      }
export function useFullTextSearchRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>(FullTextSearchRegulationsDocument, options);
        }
export type FullTextSearchRegulationsQueryHookResult = ReturnType<typeof useFullTextSearchRegulationsQuery>;
export type FullTextSearchRegulationsLazyQueryHookResult = ReturnType<typeof useFullTextSearchRegulationsLazyQuery>;
export type FullTextSearchRegulationsQueryResult = Apollo.QueryResult<FullTextSearchRegulationsQuery, FullTextSearchRegulationsQueryVariables>;
export const FullTextSearchRequirementsDocument = gql`
    query FullTextSearchRequirements($searchString: String!) {
  searchRequirements(searchString: $searchString) {
    requirements {
      id
      name
      status
      definition
      requirementId
      createdAt
      createdBy {
        givenName
        id
        mail
        name
        surname
        userPrincipalName
      }
      tags {
        id
        name
      }
      modifiedAt
      modifiedBy {
        givenName
        id
        mail
        name
        surname
        userPrincipalName
      }
      markets {
        id
        name
      }
      vexClusters {
        id
        name
      }
      driveVariants {
        id
        name
      }
      engineVariants {
        id
        name
      }
      gearboxVariants {
        id
        name
      }
      bodyworkVariants {
        id
        name
      }
      activeTypeMarkets {
        id
        name
      }
      vehicleCategories {
        id
        name
      }
      keywords {
        ...KeywordTagFields
      }
      attachments {
        attachmentId
        file {
          uri
          contentType
          fileName
        }
      }
      documentReferences {
        referenceDocumentType
        reference {
          id
          name
        }
        requirementReferences {
          id
          name
        }
      }
      assignedParagraphs {
        ...ParagraphFields
        parent {
          id
          name
          regulation {
            id
            name
            regulationNumber
            markets {
              id
              name
            }
            mainKeywords {
              id
              name
            }
            keywords {
              ...KeywordTagFields
            }
            standardPlusPcmsClusters {
              id
              name
            }
          }
        }
      }
      systemLevels {
        id
        name
        createdAt
        createdBy {
          givenName
          id
          mail
          name
          surname
          userPrincipalName
        }
        modifiedAt
        modifiedBy {
          givenName
          id
          mail
          name
          surname
          userPrincipalName
        }
      }
    }
  }
}
    ${KeywordTagFieldsFragmentDoc}
${ParagraphFieldsFragmentDoc}`;

/**
 * __useFullTextSearchRequirementsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchRequirementsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useFullTextSearchRequirementsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>(FullTextSearchRequirementsDocument, options);
      }
export function useFullTextSearchRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>(FullTextSearchRequirementsDocument, options);
        }
export type FullTextSearchRequirementsQueryHookResult = ReturnType<typeof useFullTextSearchRequirementsQuery>;
export type FullTextSearchRequirementsLazyQueryHookResult = ReturnType<typeof useFullTextSearchRequirementsLazyQuery>;
export type FullTextSearchRequirementsQueryResult = Apollo.QueryResult<FullTextSearchRequirementsQuery, FullTextSearchRequirementsQueryVariables>;
export const FullTextSearchPogisDocument = gql`
    query FullTextSearchPogis($searchString: String!) {
  searchPogisDocuments(searchString: $searchString) {
    pogisDocuments {
      associations
      createdAt
      docStatus
      editor
      id
      keywords
      linkVersion
      markets
      modifiedAt
      pogisId
      regulationStatus
      relatedDocuments
      shortInfo
      standards
      pogisAttachments {
        file {
          fileName
          uri
        }
        attachmentId
        category {
          name
        }
      }
      dates {
        date
        dateType
      }
    }
  }
}
    `;

/**
 * __useFullTextSearchPogisQuery__
 *
 * To run a query within a React component, call `useFullTextSearchPogisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchPogisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchPogisQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useFullTextSearchPogisQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>(FullTextSearchPogisDocument, options);
      }
export function useFullTextSearchPogisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>(FullTextSearchPogisDocument, options);
        }
export type FullTextSearchPogisQueryHookResult = ReturnType<typeof useFullTextSearchPogisQuery>;
export type FullTextSearchPogisLazyQueryHookResult = ReturnType<typeof useFullTextSearchPogisLazyQuery>;
export type FullTextSearchPogisQueryResult = Apollo.QueryResult<FullTextSearchPogisQuery, FullTextSearchPogisQueryVariables>;
export const FullTextSearchDocumentsDocument = gql`
    query FullTextSearchDocuments($searchString: String!) {
  searchRegulatoryDocumentsAndParagraphs(searchString: $searchString) {
    regulatoryDocuments {
      attachments {
        ...AttachmentFields
      }
      regulation {
        id
        name
        regulationNumber
      }
      createdAt
      createdBy {
        ...UserFields
      }
      id
      modifiedAt
      modifiedBy {
        ...UserFields
      }
      name
      status
      summary
      origin
      workflow {
        status
        message
      }
      document {
        uri
        contentType
        fileName
      }
      topicManagementSummary {
        quarter
        year
      }
      predecessor {
        id
        name
      }
      successor {
        id
        name
      }
      keywords {
        ...KeywordTagFields
      }
      modelYear
      dateNewRegistration
      dateNewTypes
      dateEffective
      dateExpiration
    }
    paragraphs {
      ...ParagraphFields
      parent {
        id
        regulation {
          id
          regulationNumber
          name
        }
        name
      }
    }
  }
}
    ${AttachmentFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${ParagraphFieldsFragmentDoc}`;

/**
 * __useFullTextSearchDocumentsQuery__
 *
 * To run a query within a React component, call `useFullTextSearchDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTextSearchDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTextSearchDocumentsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useFullTextSearchDocumentsQuery(baseOptions: Apollo.QueryHookOptions<FullTextSearchDocumentsQuery, FullTextSearchDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullTextSearchDocumentsQuery, FullTextSearchDocumentsQueryVariables>(FullTextSearchDocumentsDocument, options);
      }
export function useFullTextSearchDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullTextSearchDocumentsQuery, FullTextSearchDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullTextSearchDocumentsQuery, FullTextSearchDocumentsQueryVariables>(FullTextSearchDocumentsDocument, options);
        }
export type FullTextSearchDocumentsQueryHookResult = ReturnType<typeof useFullTextSearchDocumentsQuery>;
export type FullTextSearchDocumentsLazyQueryHookResult = ReturnType<typeof useFullTextSearchDocumentsLazyQuery>;
export type FullTextSearchDocumentsQueryResult = Apollo.QueryResult<FullTextSearchDocumentsQuery, FullTextSearchDocumentsQueryVariables>;